const SendIcon = ({ ...props }) => (
  <svg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M14.787 5.06545C14.8902 5.34922 14.8899 5.65635 14.7981 5.9328L11.3496 16.4091C11.0972 17.1445 10.3042 17.5436 9.5697 17.3105C9.22572 17.1872 8.93965 16.9459 8.77004 16.6235L7.05271 13.3833C6.89547 13.0866 6.95019 12.722 7.18764 12.4846L9.85248 9.81973C10.0476 9.62307 10.0495 9.30465 9.85259 9.09882C9.65311 8.90182 9.33469 8.89978 9.13168 9.09893L6.4688 11.7618C6.23042 12.0002 5.86405 12.0543 5.56691 11.8951L2.32791 10.1588C1.65189 9.79722 1.39528 8.94709 1.765 8.26652C1.93165 7.94704 2.21778 7.70729 2.56487 7.60182L13.0299 4.1646C13.7635 3.92703 14.5556 4.32837 14.787 5.06545Z'
      fill='var(--pcm-body-color)'
    />
  </svg>
);

export default SendIcon;
